import module_06fb61576b514455adabc62edb7d07ca from '../includes/glsl-compat.frag'
var fn = function( obj ){
var __t,__p='';
__p+=''+
(obj.version)+
'\nprecision '+
(obj.highp)+
' float;\n\n'+
(module_06fb61576b514455adabc62edb7d07ca())+
'\n\nIN vec2 vTexCoord;\nuniform sampler2D tFontAtlas;\nuniform vec3 uColor;\nuniform vec3 uOutlineColor;\nuniform float uOutline;\nuniform float uBlur;\n\nfloat median(float r, float g, float b) {\n  return max(min(r, g), min(max(r, g), b));\n}\n\nfloat random (vec2 st) {\n  return fract(sin(dot(st.xy, vec2(12.9898,78.233)))* 43758.5453123);\n}\n\nvoid main(void){\n\n  vec2 texcoord = vTexCoord;\n  vec4 color = texture2D(tFontAtlas, texcoord);\n\n  vec2 pos = texcoord.xy;\n  float rand = random(pos);\n  float sigDist = median(color.r, color.g, color.b);\n  sigDist += rand * 0.1 * uBlur;\n  float w = fwidth(sigDist);\n\n  float body = smoothstep(0.5 - w, 0.5 + w, sigDist);\n  float outline = smoothstep(uOutline - w, uOutline + w, sigDist);\n\n  float balpha = mix(1.0, pow(color.a, 1.5) * abs(rand + 0.5), uBlur);\n  float opacity = min(body + outline, 1.0) * balpha;\n\n  vec3 outlineColor = mix(uColor, uOutlineColor, step(0.0001, outline));\n  vec3 finalColor = mix(outlineColor, uColor, body);\n\n  FragColor = vec4(finalColor, opacity);\n\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
